var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-full',[_c('router-view',{attrs:{"language":_vm.language},on:{"selectLanguageEv":_vm.selectLang}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }